import { toast } from 'react-toastify';
import googleMapsService from '../services/GoogleMaps.service';

/**
 * Geocodes an address to coordinates using the same rules as jobsite creation:
 * - Requires a Google Maps API key (warns and returns null if missing)
 * - Only accepts ROOFTOP or RANGE_INTERPOLATED results (rejects low-confidence matches)
 * - Shows a toast warning when geocoding fails or accuracy is insufficient
 */
export const geocodeAddress = async (
  address: string,
  city: string,
  province: string,
  postalCode?: string
): Promise<[number, number] | null> => {
  if (!process.env.REACT_APP_GOOGLE_MAPS_API_KEY) {
    toast.warning('Saved successfully, but geocoding failed. Address will not appear on the map.');
    return null;
  }

  try {
    const google = await googleMapsService.loadMapsApi();
    const geocoder = new google.maps.Geocoder();

    const parts = [address, city, province];
    if (postalCode?.trim()) parts.push(postalCode.trim());
    parts.push('Canada');
    const fullAddress = parts.join(', ');

    return new Promise((resolve) => {
      geocoder.geocode({ address: fullAddress }, (results: any, status: any) => {
        const locationType = results?.[0]?.geometry?.location_type;
        const isAccurate = locationType === 'ROOFTOP' || locationType === 'RANGE_INTERPOLATED';

        if (status === 'OK' && results[0] && isAccurate) {
          const location = results[0].geometry.location;
          resolve([location.lat(), location.lng()]);
        } else {
          toast.warning('Address could not be geocoded but is saved successfully in the application.');
          resolve(null);
        }
      });
    });
  } catch (error) {
    console.error('Error geocoding address:', error);
    toast.warning('Address could not be geocoded but is saved successfully in the application.');
    return null;
  }
};
